$(document).ready(function() {
  setTimeout(function() { // 2秒遅延
    var datepickerInput       = $('#datepicker');
    var prefectureInput       = $('#prefecture');
    var earliestDateDisplay   = $('#earliest-delivery-date');
    let isDatepickerInitialized = false; // 初回クリック時のみカレンダー初期化

    // 都道府県ごとの追加日数マッピング
    const regionDaysMap = {
      "北海道":   2,
      "沖縄県":   2,
      "離島":     5,
      "大分県":   2,
      "長崎県":   2,
      "鹿児島県": 2,
      // 上記以外は "その他": 0 として扱う
      "その他":   0
    };

    // 年末年始休業期間 (選択不可)
    const disabledDates = [
      { start: new Date(2025, 11, 29), end: new Date(2026, 0, 7) }
    ];

    // 休業日(年末年始)かどうか
    function isDisabledDate(date) {
      return disabledDates.some(range => date >= range.start && date <= range.end);
    }

    // ◇土日も営業◇
    // => 単に "n日後" を計算するが, 休業期間(年末年始)はスキップ
    function addDaysSkippingYearEnd(startDate, days) {
      let date = new Date(startDate);
      while (days > 0) {
        date.setDate(date.getDate() + 1);
        if (!isDisabledDate(date)) {
          days--;
        }
      }
      return date;
    }

    // 「3月12日(火)」のような表記に変換する
    function formatDateWithWeekday(date) {
      const weekdays = ['日', '月', '火', '水', '木', '金', '土'];
      return `${date.getMonth() + 1}月${date.getDate()}日(${weekdays[date.getDay()]})`;
    }

    /**
     * 最短配送日を更新して画面に表示
     * @param {number} addDays - 都道府県による追加日数
     */
    function updateEarliestDate(addDays) {
      const today = new Date();

      // 基本の最短日は 今日 + 6日後 (土日含む5営業日 + 翌日)
      // そこに都道府県の追加日数を加算
      const baseDays = 6 + addDays;

      let earliestDate = addDaysSkippingYearEnd(today, baseDays);

      earliestDateDisplay.text(`最短ご指定可能日： ${formatDateWithWeekday(earliestDate)}`);
    }

    /**
     * カレンダーを初期化
     * @param {number} addDays - 都道府県による追加日数
     */
    function initializeDatepicker(addDays) {
      const today = new Date();

      // minDate = 今日 + 6日 + addDays (上記ロジック)
      let minDate = addDaysSkippingYearEnd(today, 6 + addDays);

      // maxDate = minDate から 6 日後 ⇒ 1週間の範囲
      let maxDate = addDaysSkippingYearEnd(minDate, 6);

      // 旧datepickerを破棄 → 新しく生成
      datepickerInput.datepicker('destroy').datepicker({
        dateFormat: 'yy/mm/dd',
        minDate: minDate,
        maxDate: maxDate,
        beforeShowDay: function(date) {
          // 年末年始休業のみ選択不可
          if (isDisabledDate(date)) {
            return [false, "", "休業日"];
          }
          return [true, "", ""];
        }
      });

      // 画面表示の最短日を更新
      updateEarliestDate(addDays);
    }

    // ◆ 初回クリック時に "show()" でカレンダーを表示 ◆
    datepickerInput.on('focus', function() {
      if (!isDatepickerInitialized) {
        let selectedPrefecture = prefectureInput.val() || "その他";
        let addDays = regionDaysMap[selectedPrefecture] || 0;
        initializeDatepicker(addDays);
        isDatepickerInitialized = true;
      }
      // カレンダーを表示
      $(this).datepicker("show");
    });

    // ◆ 都道府県が変更されたら再初期化
    prefectureInput.on('change', function() {
      let selectedPrefecture = $(this).val() || "その他";
      let addDays = regionDaysMap[selectedPrefecture] || 0;
      initializeDatepicker(addDays);
    });

    // ★ ページ読み込み時: デフォルト都道府県は "その他" で +0日
    updateEarliestDate(0);
    initializeDatepicker(0);

  }, 2000); // 2秒遅延
});
